import styled from 'styled-components';
import Layout from 'antd/lib/layout';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Content = styled<any>(Layout.Content)`
  margin: 20px;
  background-color: #fff;
  padding: 20px 35px;
`;
